import { render, staticRenderFns } from "./C5.vue?vue&type=template&id=d5540dd8&scoped=true"
import script from "./C5.vue?vue&type=script&lang=js"
export * from "./C5.vue?vue&type=script&lang=js"
import style0 from "./C5.vue?vue&type=style&index=0&id=d5540dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5540dd8",
  null
  
)

export default component.exports